
import { SkeletonCard } from "../../common/SkeletonCard.js";
import { SeriesCard } from "../../common/SeriesCard.js";
import { locale } from "../../../services/LocaleService.js";

export const TrendingSection = (data, isLoading) => {
    const section = document.createElement('section');
    // section.className = "mb-10"; // [FIX] Removed internal margin
    section.className = "";

    const header = document.createElement('div');
    header.className = "flex items-center gap-2 mb-4 px-1 md:px-0";
    header.innerHTML = `
        <span class="text-xl">🔥</span>
        <h2 class="text-xl font-bold text-gray-900">${locale.t('main.trending')}</h2>
    `;
    section.appendChild(header);

    const scrollContainer = document.createElement('div');
    scrollContainer.className = "flex gap-4 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0 scroll-smooth snap-x snap-mandatory";
    // Mobile Touch Optimization
    scrollContainer.style.webkitOverflowScrolling = 'touch';
    section.appendChild(scrollContainer);

    if (isLoading) {
        // Render 5 Skeletons
        for (let i = 0; i < 5; i++) {
            scrollContainer.appendChild(SkeletonCard());
        }
    } else if (data.length === 0) {
        scrollContainer.innerHTML = '<div class="text-gray-400 text-sm px-4">데이터가 없습니다.</div>';
    } else {
        data.forEach((series, index) => {
            // Universal Card Usage
            const card = SeriesCard(series, {
                rank: index + 1, // 1, 2, 3...
                overlayStats: true // Popularity needs stats
            });

            // External wrapper styling for horizontal scroll snap 
            // SeriesCard returns the INNER card, so we wrap it or add classes to it?
            // SeriesCard has "w-full" logic or similar? 
            // In SeriesCard.js: "w-full" is NOT enforced, but "flex-shrink-0" in TrendingSection was used.
            // Let's add the layout classes to the returned element.

            card.className = "flex-shrink-0 w-32 md:w-40 snap-start " + card.className;

            scrollContainer.appendChild(card);
        });
    }

    return section;
};
